import { MarkerProps } from '@react-google-maps/api'
import React from 'react'

export const useFacilityMarker = (isScriptLoaded: boolean) => {
  const [marker, setMarker] = React.useState<MarkerProps['icon']>(undefined)

  React.useEffect(() => {
    if (!isScriptLoaded) return

    setMarker({
      url: '/assets/markers/marker_default.png',
      anchor: new window.google.maps.Point(15, 21.5),
      size: new window.google.maps.Size(30, 43),
      scaledSize: new window.google.maps.Size(30, 43),
    })
  }, [isScriptLoaded])

  return marker
}

export const useSelectedFacilityMarker = (isScriptLoaded: boolean) => {
  const [marker, setMarker] = React.useState<google.maps.Icon | undefined>(
    undefined,
  )

  React.useEffect(() => {
    if (!isScriptLoaded) return

    setMarker({
      url: '/assets/markers/marker_selected.png',
      anchor: new window.google.maps.Point(15, 21.5),
      size: new window.google.maps.Size(30, 43),
      scaledSize: new window.google.maps.Size(30, 43),
    })
  }, [isScriptLoaded])

  return marker
}

export const useCurrentLocationMarker = (isScriptLoaded: boolean) => {
  const [marker, setMarker] = React.useState<google.maps.Icon | undefined>(
    undefined,
  )

  React.useEffect(() => {
    if (!isScriptLoaded) return

    setMarker({
      url: '/assets/markers/current_location.svg',
      anchor: new window.google.maps.Point(24, 24),
      size: new window.google.maps.Size(48, 48),
      scaledSize: new window.google.maps.Size(48, 48),
    })
  }, [isScriptLoaded])

  return marker
}
